module.exports = __webpack_public_path__ + "be7e6609f305bf0bb512d87df11d52ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/i_delete_hover.png
// module id = 281
// module chunks = 0